import type { SelectItem } from 'features/ui/elements';

export const getDefaultSelectValue = (options: SelectItem[]) => {
  return options.find((item) => item.isDefault)?.value;
};
